import React, { useEffect, useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import { Grid } from "@material-ui/core";
import Input from "Components/Input/Input";
import { toggleNPercentRiyal } from "Constants/Constants";
import { FACTOR_RESULT } from "Stores/actionTypes";
import Translator from "Languages/Utility/Translator";
import { useTranslation } from "react-i18next";

export default function SettingsBasePriceCharge() {
  const { t } = useTranslation();
  const { factorResult } = useSelector((state) => ({
    factorResult: state.factor.factorResult,
  }));
  const dispatch = useDispatch();
  const [formValid, setFormValid] = useState({});
  const [controls, setControls] = useSetState({
    ChargePriceProfile: {
      type: "price",
      value: 0,
      box: 1,
      validation: {
        required: true,
        isPrice: true,
      },
      relation: 'IsPercentChargePriceProfile',
      label: 'Profile',
    },
    IsPercentChargePriceProfile: {
      type: "toggle",
      arrayItems: toggleNPercentRiyal,
      relation: 'ChargePriceProfile',
      value: toggleNPercentRiyal[0],
      validation: {
        required: true,
      },
    },
    ChargePriceFitting: {
      type: "price",
      value: 0,
      box: 1,
      validation: {
        required: true,
        isPrice: true,
      },
      relation: 'IsPercentChargePriceFitting',
      label: 'Fitting',
    },
    IsPercentChargePriceFitting: {
      type: "toggle",
      arrayItems: toggleNPercentRiyal,
      relation: 'ChargePriceFitting',
      value: toggleNPercentRiyal[0],
      validation: {
        required: true,
      },
    },
    ChargePriceGlass: {
      type: "price",
      value: 0,
      box: 1,
      validation: {
        required: true,
        isPrice: true,
      },
      relation: 'IsPercentChargePriceGlass',
      label: 'Glass',
    },
    IsPercentChargePriceGlass: {
      type: "toggle",
      arrayItems: toggleNPercentRiyal,
      relation: 'ChargePriceGlass',
      value: toggleNPercentRiyal[0],
      validation: {
        required: true,
      },
    },
    ChargePriceNet: {
      type: "price",
      value: 0,
      box: 1,
      validation: {
        required: true,
        isPrice: true,
      },
      relation: 'IsPercentChargePriceNet',
      label: 'Net',
    },
    IsPercentChargePriceNet: {
      type: "toggle",
      arrayItems: toggleNPercentRiyal,
      relation: 'ChargePriceNet',
      value: toggleNPercentRiyal[0],
      validation: {
        required: true,
      },
    },
    ChargePriceOther: {
      type: "price",
      value: 0,
      box: 1,
      validation: {
        required: true,
        isPrice: true,
      },
      relation: 'IsPercentChargePriceOther',
      label: 'materials',
    },
    IsPercentChargePriceOther: {
      type: "toggle",
      arrayItems: toggleNPercentRiyal,
      relation: 'ChargePriceOther',
      value: toggleNPercentRiyal[0],
      validation: {
        required: true,
      },
    },
  });

  useEffect(() => {
    setControls({ ChargePriceFitting: { value: factorResult.ChargePriceFitting } });
    setControls({ ChargePriceGlass: { value: factorResult.ChargePriceGlass } });
    setControls({ ChargePriceNet: { value: factorResult.ChargePriceNet } });
    setControls({ ChargePriceOther: { value: factorResult.ChargePriceOther } });
    setControls({ ChargePriceProfile: { value: factorResult.ChargePriceProfile } });
    setControls({ IsPercentChargePriceProfile: { value: factorResult.IsPercentChargePriceProfile ? toggleNPercentRiyal[0] : toggleNPercentRiyal[1] } });
    setControls({ IsPercentChargePriceFitting: { value: factorResult.IsPercentChargePriceFitting ? toggleNPercentRiyal[0] : toggleNPercentRiyal[1] } });
    setControls({ IsPercentChargePriceGlass: { value: factorResult.IsPercentChargePriceGlass ? toggleNPercentRiyal[0] : toggleNPercentRiyal[1] } });
    setControls({ IsPercentChargePriceNet: { value: factorResult.IsPercentChargePriceNet ? toggleNPercentRiyal[0] : toggleNPercentRiyal[1] } });
    setControls({ IsPercentChargePriceOther: { value: factorResult.IsPercentChargePriceOther ? toggleNPercentRiyal[0] : toggleNPercentRiyal[1] } });
  },[factorResult])

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
    if(validation) {
      const result = {
        ...factorResult,
        [name]: +value,
      };
      dispatch({ type: FACTOR_RESULT, factorResult: result });
    }
  };

  const onChangeToggle = (name, key, value) => {
    setControls({ [name]: { value: value } });
    setControls({ [controls[name].relation]: { value: 0 } });
    const result = {
      ...factorResult,
      [name]: value.value,
      [controls[name].relation]: 0,
    };
    dispatch({ type: FACTOR_RESULT, factorResult: result });
  };


  return (
    <Grid item xs={12} md={6}>
      <Grid xs={12} className="box-re-border p-2">
        <div className="my-3 pb-2">
          <p className="normalTitle">{t('basePriceCharge')}</p>
        </div>
        {
          Object.keys(controls).filter(key => controls[key].box === 1).map((key, index) => {
            return (
              <Grid container spacing={2} key={key + index}>
                <Grid item xs={12}>
                  <Input
                    setValue={setValue.bind(this)}
                    value={controls[key].value}
                    name={key}
                    validation={controls[key].validation}
                    label={<Translator id={controls[key].label}/>}
                    endIcon={controls[controls[key].relation].value.value ? "%" : <Translator id={'moneyUnit'}/>}
                    type={controls[key].type}
                    radioGroup={{
                      name: controls[key].relation,
                      value: controls[controls[key].relation].value,
                      items: controls[controls[key].relation].arrayItems,
                      onChange: onChangeToggle,
                    }}
                  />
                </Grid>
              </Grid>
            )
          })
        }
      </Grid>
    </Grid>
  );
}